import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'commerce',
  name: fr.title,
  description: fr.description,
  icon: 'grid',
  color: '#1D4ED8',
  glyph: [{ d: 'M3 4h2l3 11h10l3-8H6' }, { d: 'M9 19h.01M17 19h.01' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: [
      'app.records.read',
      'app.records.write',
      'external.productions.read',
      'contacts.read',
      'tickets.read',
      'tickets.write',
      'interactions.write',
    ],
    defines: [],
  },
  entities: {
    uses: [
      { entity: 'contacts' },
      { entity: 'tickets', extends: { status: ['open'], channel: ['web'] } },
      { entity: 'interactions', extends: { channel: ['request'] } },
    ],
    owns: ['plans', 'reports', 'history', 'receipts', 'cases'].map((table) => ({
      table,
      scope: 'workspace' as const,
      description: fr.description,
    })),
  },
  events: {
    emits: emitsOf(events),
    subscribes: [],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: { actions: ['commerce.seed'], conditions: ['commerce.completed'], blocks: [] },
  migrations: { schema: 'app_commerce', dir: 'migrations' },
});
